var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sign-out auth component",on:{"click":_vm.out}},[_vm._v(_vm._s(_vm.$t('Sign Out')))])}
var staticRenderFns = []

export { render, staticRenderFns }